import { queryOptions, useQuery } from "@tanstack/react-query";

import data from "../../assets/mocks/market-trends.json";

import { api } from "@/lib/api-client";
import { hasAccessToken } from "@/lib/auth";
import { AxiosMock } from "@/utils/mock";

import type { QueryConfig } from "@/lib/react-query";
import type { MarketTrends } from "@/types/market";

if (import.meta.env.MODE === "test") {
  // Mocking the API response for watchlists
  const mock = AxiosMock.getInstance();
  mock.onGet("/carburate/market/trends/").reply(200, data);
}

export const getMarketTrends = () => {
  return api.get("/carburate/market/trends/") as Promise<MarketTrends>;
};

export const getMarketTrendsQueryOptions = () => {
  return queryOptions({
    queryKey: ["market", "trends"],
    queryFn: getMarketTrends,
  });
};

type UseMarketTrendsOptions = {
  queryConfig?: QueryConfig<typeof getMarketTrends>;
};

export const useMarketTrends = ({ queryConfig }: UseMarketTrendsOptions = {}) => {
  return useQuery({
    enabled: hasAccessToken(),
    ...getMarketTrendsQueryOptions(),
    ...queryConfig,
  });
};
